var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.statusBinding)?_c('div',{staticClass:"label font-weight-bold label-lg label-inline",class:[_vm.statusBinding.variant, 'mb-1'],staticStyle:{"width":"max-content"}},[_vm._v(" "+_vm._s(_vm.statusBinding.text)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }